module.exports = __webpack_public_path__ + "img/login-ciudadelahospitalaria.5d50340e.svg";